import React, { ChangeEvent, FC, InputHTMLAttributes, isValidElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import styles from './styles.module.scss';

export interface InputChangeProps {
    checked?: boolean,
    files?: FileList,
    name: string,
    value?: any,
}

export interface InputProps {
    error?: boolean | string,
    icon?: IconDefinition | JSX.Element,
    onChange?: (data: any, e: ChangeEvent<HTMLInputElement>) => void,
    transparent?: boolean,
}

const Input: FC<InputProps & InputHTMLAttributes<HTMLInputElement>> = ({
    className,
    error,
    icon,
    onChange,
    transparent,
    value,
    ...props
}): JSX.Element => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange({
                checked: e.currentTarget.checked,
                files: e.currentTarget.files,
                name: e.currentTarget.name,
                value: e.currentTarget.value,
            }, e);
        }
    }

    return (
        <div
            className={[
                styles.base,
                transparent && styles.transparent,
            ].join(' ')}
        >
            {icon && (isValidElement(icon) ? icon : <FontAwesomeIcon icon={icon as IconDefinition} />)}
            <input
                className={[
                    styles.input,
                    error && styles.error,
                    icon && styles.withIcon,
                    className,
                ].join(' ')}
                onChange={handleChange}
                value={value || ''}
                {...props}
            />
        </div>
    )
}

export default Input;
